import React from 'react';

/**
 * Button group for a Reference MET catalog question.
 *
 * @param {Object} props
 * @param {string} props.questionText   Exact wording from question_definitions.
 * @param {Array<{answer_code: string, answer_text: string, answer_definition?: string|null}>} props.answers
 *        Options in display order. Only options that lead to a supported
 *        combination should be passed in.
 * @param {string|null} props.value     Selected answer_code.
 * @param {(code: string) => void} props.onChange
 * @param {string} [props.name]         Used for aria grouping.
 */
const AnswerChoiceGroup = ({ questionText, answers, value, onChange, name }) => {
    const selected = answers.find((a) => a.answer_code === value) || null;

    return (
        <div className="la-field" role="radiogroup" aria-label={questionText}>
            <label className="la-label">{questionText}</label>
            <div className="la-choice-group">
                {answers.map((answer) => {
                    const active = answer.answer_code === value;
                    return (
                        <button
                            key={answer.answer_code}
                            type="button"
                            role="radio"
                            aria-checked={active}
                            name={name}
                            className={`la-choice-btn${active ? ' active' : ''}`}
                            onClick={() => onChange(answer.answer_code)}
                        >
                            <span className="la-choice-text">{answer.answer_text}</span>
                        </button>
                    );
                })}
            </div>
            {selected?.answer_definition && (
                <p className="la-choice-definition">{selected.answer_definition}</p>
            )}
        </div>
    );
};

export default AnswerChoiceGroup;
